var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalMask',{attrs:{"inline":_vm.inline}},[_c('div',{staticClass:"loading-message"},[_c('LoadingIndicator',{staticClass:"loading"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }